import merge from 'lodash/merge';

export const encodeObject = (object) => {
  const isEncoding = true;
  return transformObject(object, isEncoding);
};

export const decodeObject = (object) => {
  const isEncoding = false;
  return transformObject(object, isEncoding);
};

const transformObject = (object, isEncoding) => {
  const toEntry = (object, key) => [key, object[key]];
  const transformEntries = (key) =>
    transformEntry(toEntry(object, key), isEncoding);
  const transformedObject = Object.keys(object).map(transformEntries);

  return merge(...transformedObject);
};

const transformEntry = (entry, isEncoding) => {
  const [name, value] = entry;
  const isString = value && typeof value === 'string';
  const isObject = value && typeof value === 'object';

  let operation = (value) => value;
  if (isObject) operation = isEncoding ? encodeObject : decodeObject;
  if (isString) operation = isEncoding ? encodeString : decodeString;

  return { [name]: operation(value) };
};

export const encodeString = (input) => window.btoa(encodeUnicode(input));
export const decodeString = (input) => decodeUnicode(window.atob(input));

const decodeUnicode = (str) =>
  decodeURIComponent(
    str
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );
const toSolidBytes = (match, p1) => String.fromCharCode('0x' + p1);
const encodeUnicode = (str) =>
  encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, toSolidBytes);
